import { RefObject } from "react";
import { ConnectedBookingData } from "../../../../features/Booking-Form/typings/connected-bookingData";

export const calculateTagLimit = (
  containerRef: RefObject<HTMLDivElement>,
  containerPadding: number,
  selectedColleagueFilter: ConnectedBookingData[],
  setTagLimit: (l: number) => void
) => {
  if (!containerRef.current) return;

  const containerWidth = containerRef.current.offsetWidth;
  const xMoreColleaguesChip = 30; // Width for the "+X" chip
  const rawChipWidth = 45; //ChipWidth without letters in it
  const letterWidth = 7.35; // Average width of a letter
  const marginBetweenChips = 6;

  //Calculate how much space of the Autocomplete is available for the chips
  let availableWidth = containerWidth - containerPadding - xMoreColleaguesChip;

  let tagLimit = 0;

  //Calculate how many colleague chips fit into the Autocomplete
  selectedColleagueFilter.forEach(colleague => {
    /**
     * The +1 is for the spacing between firstname and lastname.
     * First count the letters of each name, then multiply by average letter width and
     * add rest of chipwidth to get approximate chip width of current colleague.
     * Lastly, round the sum up so that we have an integer.
     */
    availableWidth =
      availableWidth -
      Math.ceil(
        (colleague.firstName.length + colleague.lastName.length + 1) * letterWidth +
          rawChipWidth +
          marginBetweenChips
      );
    //If current chip doesn't fit into the available space, quit this loop, otherwise increment the tagLimit
    if (availableWidth < 0) return;
    tagLimit++;
  });

  setTagLimit(tagLimit);
};
